// import React, { useEffect } from 'react';
// import { getQuoteById } from '../../store/slices/customerSlice';
// import AcceptQuoteLayout from '../../layouts/AcceptQuoteLayout';
// import { useDispatch, useSelector } from 'react-redux';
// import OrderGenerate from "../Customer/OrderGenerate";
// import { useParams } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import axios from 'axios';

// const AcceptOrder = ({ bill, request }) => {
//   const { id } = useParams();
//   const dispatch = useDispatch();
//   const { orderDetails } = useSelector((state) => state.customer);
//   const { orderData } = useSelector((state) => state.supplier);
//   const token = localStorage.getItem("accessToken");

//   const handleOrder = async () => {
//     try {
//       const header = {
//         headers: {
//           "Authorization": `Bearer ${token}`
//         }
//       }
//       let res = await axios.post(`${process.env.REACT_APP_SERVER_URL}/orders/generate/${id}`, "", header);
//       // toast.success(`${res.data?.message} ⭐`);
//       // console.log("API Response:", res.data);

//       dispatch(getQuoteById(id));
//     } catch (error) {
//       console.error("Order Generation Error:", error);
//       // console.log("Error Response:", error?.response);
//       // console.log("Error Message:", error?.response?.data?.message);
//       let err = error.response?.data?.message;
//       toast.error(err);
//     }
//   }

//   useEffect(() => {
//     dispatch(getQuoteById(id));
//   }, [dispatch, id])

//   useEffect(() => { }, [orderDetails, orderData])
//   return (
//     <div>
//       <AcceptQuoteLayout id={id} handleOrder={handleOrder} request={request} bill={bill} />
//       {orderData && orderDetails ? <OrderGenerate orderData={orderData} showButton={true} /> : ""}
//     </div>
//   )
// }

// export default AcceptOrder;

import React, { useEffect, useState } from 'react';
import { getQuoteById } from '../../store/slices/customerSlice';
import AcceptQuoteLayout from '../../layouts/AcceptQuoteLayout';
import { useDispatch, useSelector } from 'react-redux';
import OrderGenerate from "../Customer/OrderGenerate";
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { refreshIfNeeded } from '../../store/actions/refreshIfNeeded';

const AcceptOrder = ({ bill, request }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { orderDetails } = useSelector((state) => state.customer);
  const { orderData } = useSelector((state) => state.supplier);

  // Optional: helps prevent double-clicks on Generate Order
  const [ordering, setOrdering] = useState(false);

  // --- Same helper style as in RevertModal ---
  const authHeaders = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      'Content-Type': 'application/json',
    },
  });

  const ensureAuth = async () => {
    // Refresh token if needed before making API call
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };

  const handleOrder = async () => {
    if (!id) {
      toast.error('Missing quote id');
      return;
    }
    if (ordering) return; // guard against rapid clicks

    setOrdering(true);
    try {
      const headers = await ensureAuth();
      const url = `${process.env.REACT_APP_SERVER_URL}/orders/generate/${id}`;

      // ✅ Send a JSON body (empty object) since Content-Type is application/json
      await axios.post(url, {}, headers);

      // Optional success toast:
      // toast.success('Order generated successfully!');

      // Refresh quote to update UI
      await dispatch(getQuoteById(id));
    } catch (error) {
      const errMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Something went wrong!';
      toast.error(errMessage);
      console.error('Order Generation Error:', error);
    } finally {
      setOrdering(false);
    }
  };

  useEffect(() => {
    if (id) dispatch(getQuoteById(id));
  }, [dispatch, id]);

  return (
    <div>
      <AcceptQuoteLayout
        id={id}
        handleOrder={handleOrder}
        request={request}
        bill={bill}
        // Pass down if you want to disable/show spinner in your button
        ordering={ordering}
      />
      {orderData && orderDetails ? (
        <OrderGenerate orderData={orderData} showButton={true} />
      ) : null}
    </div>
  );
};

export default AcceptOrder;
